import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Plane, Newspaper } from "lucide-react";
import api from "../lib/api";
import { Spinner } from "../components/common";
import WikiPanel from "../components/WikiPanel";
import NewsFeed from "../components/NewsFeed";

export default function ManufacturerDetail() {
  const { name } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setD(null); setErr(false);
    api.get(`/manufacturers/${encodeURIComponent(name)}`).then((r) => setD(r.data)).catch(() => setErr(true));
  }, [name]);

  if (err) return <div className="max-w-3xl mx-auto px-5 py-24 text-center text-muted-foreground">Manufacturer not found.</div>;
  if (!d) return <Spinner full />;

  return (
    <div data-testid="manufacturer-detail" className="max-w-7xl mx-auto px-5 lg:px-8 py-10">
      <Link to="/manufacturers" className="inline-flex items-center gap-1 text-sm text-primary hover:underline mb-4"><ArrowLeft className="w-4 h-4" /> Manufacturers</Link>
      <h1 className="font-heading font-900 text-4xl sm:text-5xl tracking-tight">{d.name}</h1>
      <p className="mt-2 text-muted-foreground font-mono text-sm">{d.count} aircraft types</p>

      <div className="grid lg:grid-cols-3 gap-10 mt-8">
        <div className="lg:col-span-2 space-y-8">
          <WikiPanel title={d.name} />
          <div>
            <h2 className="font-heading font-700 text-xl mb-4 flex items-center gap-2"><Newspaper className="w-5 h-5 text-primary" /> Latest news</h2>
            <NewsFeed path={`/news?category=general&q=${encodeURIComponent(d.name)}&limit=10&archive_as=manufacturer`} />
          </div>
        </div>
        <div>
          <h2 className="font-heading font-700 text-xl mb-4 flex items-center gap-2"><Plane className="w-5 h-5 text-primary -rotate-45" /> Aircraft</h2>
          <div className="space-y-2 max-h-[600px] overflow-auto pr-1">
            {d.aircraft.map((a) => (
              <Link key={a.id} to={`/aircraft/${encodeURIComponent(a.iata || a.icao || a.id)}`} data-testid={`mfr-aircraft-${a.iata || a.id}`}
                className="flex items-center justify-between border border-zinc-300 bg-white px-4 py-2.5 hover:border-primary transition-colors">
                <span className="text-sm font-medium truncate">{a.name}</span>
                <span className="font-mono text-xs text-primary">{a.iata || a.icao}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
